import { getConfig } from '@/lib/config'

interface LoaderProps {
  src: string
  width: number
  height?: number
  quality?: number
}

const { publicRuntimeConfig } = getConfig()

export function isImageSupportedByCloudflareResizer(imageUrl: string): boolean {
  const cloudflareImagesDomain = publicRuntimeConfig.cloudflareImages.url
  return imageUrl.startsWith(cloudflareImagesDomain)
}

export const cloudflareImageLoader = (props: LoaderProps): string => {
  if (!isImageSupportedByCloudflareResizer(props.src)) return props.src

  try {
    const url = new URL(props.src)
    url.searchParams.set('w', String(props.width))

    if (props.height) {
      url.searchParams.set('h', String(props.height))
    }

    if (props.quality) {
      url.searchParams.set('q', String(props.quality))
    }

    return url.toString()
  } catch (error) {
    console.error({ error }, 'cloudflareImageLoader')
    return props.src
  }
}
